import PropTypes from 'prop-types'
import c from 'classnames'
import styles from './RoundMiniIcon.module.scss'

const RoundMiniIcon = ({ bg, color, icon }) => (
  <div
    className={c(
      styles.base,
      `b-${bg}`,
      `c-${color}`,
      `border-${bg || 'white'}`
    )}
  >
    {(icon && <i className={`icon icon-${icon}`} />) || null}
  </div>
)

RoundMiniIcon.defaultProps = {
  bg: 'grey',
  color: 'white',
}
RoundMiniIcon.propTypes = {
  bg: PropTypes.oneOf(['white', 'grey', false]),
  color: PropTypes.oneOf(['brand', 'white']),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default RoundMiniIcon
